const url = window.location.href.split('/');

export const APP = 'merchant';

export const SITE_URL = url[2];

export const PLATFORM = (type = 'api') => {
  switch(SITE_URL) {
    case 'localhost:17006':
      //return 'https://b98b911b.ngrok.io';
      return type === 'api' ? 'http://localhost:17002' : 'development';

    // vagrant windows ip
    case '10.0.2.2:17006':
      return type === 'api' ? 'https://api.staging.localvore.co' : 'development';

    case 'merchants.staging.localvore.co':
      return type === 'api' ? 'https://api.staging.localvore.co' : 'staging';

    case 'merchants.localvore.co':
      return type === 'api' ? 'https://08232017.prod.localvore.co' : 'production';

    default:
      return type === 'api' ? 'http://localhost:17002' : 'development';
  }
}

export const API_VERSION = '2016-10-28'

export const REQUEST_DEFAULTS  = {
  data:{
    id: 'localvore.subscriber.web',
    attributes: {
      scope: 'merchant'
    }
  }
}

export const ENHANCED_PLAN = 'enhanced-full';

export const COOKIE = '_localvore'

export const IMAGE_URL = 'https://res.cloudinary.com/localvore-today/image/upload/';
export const INSTAGRAM_CALLBACK_URL = 'https://' + SITE_URL + '/oauth/instagram'

export const CUISINE_LIST = [{
  value: '',
  label: 'Choose'
},{
  value: 'arab',
  label: 'Arab'
},{
  value: 'armenian',
  label: 'Armenian'
},{
  value: 'american-new',
  label: 'American (New)'
},{
  value: 'american-southern',
  label: 'American (Southern)'
},{
  value: 'american-southwestern',
  label: 'American (Southwestern)'
},{
  value: 'argentinian',
  label: 'Argentinian'
},{
  value: 'asian',
  label: 'Asian'
},{
  value: 'bulgarian',
  label: 'Bulgarian'
},{
  value: 'barbecue',
  label: 'Barbecue'
},{
  value: 'cajun',
  label: 'Cajun'
},{
  value: 'caribbean',
  label: 'Caribbean'
},{
  value: 'chinese',
  label: 'Chinese'
},{
  value: 'cuban',
  label: 'Cuban'
},{
  value: 'ethiopian',
  label: 'Ethiopian'
},{
  value: 'west-african',
  label: 'West African'
},{
  value: 'east-african',
  label: 'East African'
},{
  value: 'english',
  label: 'English'
},{
  value: 'south-african',
  label: 'South African'
},{
  value: 'french',
  label: 'French'
},{
  value: 'filipino',
  label: 'Filipino'
},{
  value: 'gastro-pub',
  label: 'Gastro Pub'
},{
  value: 'german',
  label: 'German'
},{
  value: 'greek',
  label: 'Greek'
},{
  value: 'hawaiian',
  label: 'Hawaiian'
},{
  value: 'korean',
  label: 'Korean'
},{
  value: 'irish',
  label: 'Irish'
},{
  value: 'indian',
  label: 'Indian'
},{
  value: 'indonesian',
  label: 'Indonesian'
}, {
  value: 'italian',
  label: 'Italian'
}, {
  value: 'japanese',
  label: 'Japanese'
}, {
  value: 'jewish',
  label: 'Jewish'
}, {
  value: 'louisiana-creole',
  label: 'Louisiana Creole'
}, {
  value: 'mexican',
  label: 'Mexican'
}, {
  value: 'mediterranean',
  label: 'Mediterranean'
}, {
  value: 'moroccan',
  label: 'Moroccan'
}, {
  value: 'nepalese',
  label: 'Nepalese'
}, {
  value: 'polish',
  label: 'Polish'
}, {
  value: 'pakistani',
  label: 'Pakistani'
}, {
  value: 'peruvian',
  label: 'Peruvian'
}, {
  value: 'portuguese',
  label: 'Portuguese'
}, {
  value: 'ecuadorian',
  label: 'Ecuadorian'
}, {
  value: 'seafood',
  label: 'Seafood'
}, {
  value: 'serbian',
  label: 'Serbian'
}, {
  value: 'spanish',
  label: 'Spanish'
}, {
  value: 'tapas',
  label: 'Tapas'
}, {
  value: 'thai',
  label: 'Thai'
}, {
  value: 'turkish',
  label: 'Turkish'
}, {
  value: 'vegetarian',
  label: 'Vegetarian'
}]

export const BREAKPOINTS = {
  xsOnly: '(max-width: 575px)',
  smOnly: '(min-width: 576px) and (max-width: 767px)',
  mdOnly: '(min-width: 768px) and (max-width: 991px)',
  lgOnly: '(min-width: 992px) and (max-width: 1199px)',
  xlOnly: '(min-width: 1200px)',
  smUp: '(min-width: 576px)',
  mdUp: '(min-width: 768px)',
  lgUp: '(min-width: 992px)',
  xlUp: '(min-width: 1200px)',
  xsDown: '(max-width: 575px)',
  smDown: '(max-width: 767px)',
  mdDown: '(max-width: 991px)',
  lgDown: '(max-width: 1199px)',
}



// WEBPACK FOOTER //
// ./src/constants/SiteVariables.js